import { AnchorHTMLAttributes, FC, Fragment, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import isLinkToAnotherWorld from '../../utils/is-link-to-another-world';
import isPrerender from '../../utils/is-prerender';
import getMaterialLink from '../../utils/url/get-material-link';

type MaterialLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
    item: Material;
    children?: ReactNode;
    internalPath?: string;
    omitForBots?: boolean;
};

const MaterialLink: FC<MaterialLinkProps> = ({ item, internalPath, omitForBots, children, ...restProps }) => {
    const href = getMaterialLink(item, internalPath);
    const isCrossWorld = isLinkToAnotherWorld(href);

    if (omitForBots && isPrerender()) {
        return <>{children}</>;
    }

    if (isCrossWorld) {
        return (
            <Fragment>
                <a {...restProps} href={href}>
                    {children}
                </a>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Link {...restProps} to={href} state={{ material: item }}>
                {children}
            </Link>
        </Fragment>
    );
};

export default MaterialLink;
